module.exports = __webpack_public_path__ + "static/TWAUS-trader-text-mobile-29e776240fcf38b50e994740476a19b1.png";